import React from 'react';
import StaticItem from "../../Components/StaticItem/StaticItem";
import SliderWrapper from "../../Components/SliderWrapper/SliderWrapper";
export var StaticItemCarousel = function StaticItemCarousel(_ref) {
  var data = _ref.data,
    name = _ref.name,
    metadata = _ref.metadata;
  var _ref2 = metadata || {},
    style = _ref2.style;
  return /*#__PURE__*/React.createElement(SliderWrapper, null, data.map(function (item, idx) {
    var title = item.title,
      subtitle = item.subtitle,
      image = item.image;
    return /*#__PURE__*/React.createElement("div", {
      key: "widget_".concat(name, "_item_").concat(idx)
    }, /*#__PURE__*/React.createElement("div", {
      style: style
    }, /*#__PURE__*/React.createElement(StaticItem, {
      title: title,
      subtitle: subtitle,
      image: image,
      widgetName: name
    })));
  }));
};
export default StaticItemCarousel;